// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CvaQ","badges":"styles_badges__29zfR"};